export default "__VITE_ASSET__UPisj83d__"